import './styles/index.scss'
import App from './App'
import * as Sentry from '@sentry/react'
import { render } from 'preact';
import {isCancel} from "./httpClient";

if (typeof window !== 'undefined') {
  Sentry.init({
    dsn: 'https://26d7dd35e0e14b10809e8ea0e9161f60@o1121375.ingest.sentry.io/6157841',
    integrations: [
        Sentry.browserTracingIntegration(),
    ],
    replaysSessionSampleRate: import.meta.env.VITE_ENVIRONMENT === 'production' ? 0.1 : 1,
    replaysOnErrorSampleRate: 1.0,
    tracesSampleRate: import.meta.env.VITE_ENVIRONMENT === 'production' ? 0.2 : 1,
    environment: import.meta.env.VITE_ENVIRONMENT,
    beforeSend (event, hint) {
      const environmentWhiteList = ['development', 'staging', 'production']
      if (environmentWhiteList.includes(import.meta.env.VITE_ENVIRONMENT || '') && import.meta.env.NODE_ENV === 'production') {
        if (isCancel(hint?.originalException)) {
          return null;
        }
        return event
      }
      return null
    },
  })
}

render(<App />, document.getElementById('app'));
